import React from 'react';

const LoadingSpinner = () => (
  <div style={{ textAlign: 'center', padding: '40px 0' }}>
    <div
      className="spinner-border"
      role="status"
      style={{ color: '#C73B33', width: '3rem', height: '3rem' }}
    >
      <span className="visually-hidden">Cargando...</span>
    </div>
    <p style={{ marginTop: '12px', color: '#888', fontSize: '14px' }}>Cargando...</p>
  </div>
);

export default LoadingSpinner;
